<template>
  <form-build-component
    form-name=""
    :form-data="formData"
    :form-columns-group="formColumnsGroup"
    :form-rules="formRules"
    :border="true"
    class="formTable"
  ></form-build-component>
</template>

<script>
  import moment from 'moment'
  import FormBuildComponent from "../../components/FormBuild";
  import Status2CN from "../../filters/Status2CN";
  import repaymentFormulaOptions from "../../utils/repaymentFormulaOptions";
  import lendingFeePayTimeOptions from "../../utils/lendingFeePayTimeOptions";
  import lendingFeeTypeOptions from "../../utils/lendingFeeTypeOptions";
  import interestTypeOptions from "../../utils/interestTypeOptions";
  export default {
    name: "FinancingApplyingFormComponent",
    components: {FormBuildComponent},
    data: function () {
      return {

        formRules: {}
      }
    },
    props: {
      value: {
        type: Object,
        default:()=>{}
      }
    },
    watch: {
      formData: {
        handler: function (newVal) {
          if(newVal.fi__repaymentFormula != 'DQHK') {
            this.formData.fi__endDate = moment(newVal.fi__startDate).add(newVal.fi__repaymentCount, 'month').subtract(1, 'days').format('YYYY-MM-DD')
          }
        },
        deep: true
      }
    },
    computed: {
      formData: {
        get() {
          return this.value
        },
        set(newVal) {
          this.emit('input', newVal)
        }
      },
      formColumnsGroup: {
        get: function () {
          return [
            {
              label: '贷款申请信息',
              columns: [
                {
                  label: '贷款申请编号',
                  field: 'fi__applicationNo'
                },
                {
                  label: '贷款申请状态',
                  field: 'fi__applicationStatus',
                  formatter: function (r, v) {
                    return Status2CN(v)
                  }
                },
               /* {
                  label: '贷款申请日期',
                  field: 'fi__applicationDate',
                  formatter: function (r, v) {
                    return moment(v).format('YYYY-MM-DD HH:mm:ss')
                  }
                },*/
                {
                  label: '客户名称',
                  field: 'fi__customerName'
                },
                {
                  label: '客户手机号',
                  field: 'i__contactTelNo'
                },
                {
                  label: '合同编号',
                  field: 'ct__contractNo'
                },
                {
                  label: '贷款产品',
                  field: 'ct__productName',
                },
                {
                  label: '贷款金额',
                  field: 'fi__totalAmount',
                  unit: '元',
                  component: 'el-input',
                  span: 12
                },
                {
                   label: '币别',
                   field: 'pi__currencyCode',
                   formatter: function (r, v) {
                   return '人民币'
                   }
                },
                {
                  label: '贷款开始日期',
                  field: 'fi__startDate',
                  component: 'el-date-picker',
                  valueFormat: 'yyyy-MM-dd',
                  pickerOptions: {
                    disabledDate:(time)=>{
                      return time.getTime() < new Date().valueOf()
                    }
                  },
                  span: 12
                },
                {
                  label: '贷款结束日期',
                  field: 'fi__endDate',
                  component: 'el-date-picker',
                  valueFormat: 'yyyy-MM-dd',
                  readonly: this.formData.fi__repaymentFormula != 'DQHK',
                  pickerOptions: {
                    disabledDate:(time)=>{
                      return time.getTime() < new Date(this.formData.fi__startDate).valueOf()
                    }
                  },
                  span: 12
                },
                {
                  label: '提款申请时间',
                  field: 'fi__endDate',
                  component: 'el-date-picker',
                  valueFormat: 'yyyy-MM-dd',
                  readonly: this.formData.fi__repaymentFormula != 'DQHK',
                  pickerOptions: {
                    disabledDate:(time)=>{
                      return time.getTime() < new Date(this.formData.fi__startDate).valueOf()
                    }
                  },
                  span: 12
                },
                {
                  label: '贷款比例',
                  field: 'ct__financingRatio',
                  unit: '%'
                },
                {
                  label: '贷款利率',
                  field: 'fi__interestRate',
                  component: 'el-input',
                  unit: '%'
                },
                {
                  label: '贷款利率收取方式',
                  field: 'fi__interestType',
                  component: 'el-select',
                  options: interestTypeOptions
                },
                {
                  label: '服务费',
                  field: 'fi__lendingFee',
                  component: 'el-input',
                  unit: this.formData.fi__lendingFeeType == 'Rate' ? '%' : '元'
                },
                {
                  label: '服务费收取方式',
                  field: 'fi__lendingFeeType',
                  component: 'el-select',
                  options: lendingFeeTypeOptions
                },
                {
                  label: '利息收取节点',
                  field: '',
                  component: 'el-select',
                  options: lendingFeePayTimeOptions
                },
                {
                  label: '费用收取节点',
                  field: 'fi__lendingFeePayTime',
                  component: 'el-select',
                  options: lendingFeePayTimeOptions
                },
                {
                  label: '还款方式',
                  field: 'fi__repaymentFormula',
                  component: 'el-select',
                  options: repaymentFormulaOptions
                },
                {
                  label: '还款期数',
                  field: 'fi__repaymentCount',
                  unit: '月',
                  component: 'el-input'
                },
                {
                  label: '贷款用途',
                  field: 'fi__intendedUse',
                  component: 'el-input',
                },


/*
                {
                  label: '收款账户',
                  field: 'la__bank',
                  formatter: function (r, v) {
                    return r.la__bank + ' ' + r.la__branch + ' ' + r.la__accountName + ' ' + r.la__accountNo
                  },
                  span: 24
                },
                {
                  label: '还款账户',
                  field: 'ra__bank',
                  formatter: function (r, v) {
                    return r.ra__bank + ' ' + r.ra__branch + ' ' + r.ra__accountName + ' ' + r.ra__accountNo
                  },
                  span: 24
                }*/
              ]
            }
          ]
        },
        set(newVal) {
          console.log(newVal)
        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/FinancingApplyingFormComponent.vue